import type { Asset } from 'src/Types/AssetTypes'
import type { TFunction } from 'i18next'

export const getSystemNameByAsset = ({ assetType }: Pick<Asset, 'assetType'>, t: TFunction) =>
  t(`sideMenu.system.${assetType.toLowerCase()}`)
